var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-mini-basket"},_vm._l((_vm.basket.orderLines),function(orderline){return _c('div',{key:orderline.id},[_c('orderline-compact',{attrs:{"product":orderline}}),_vm._v(" "),_c('hr')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }